export const DOWNLOAD_OPTINS_REQUEST = 'DOWNLOAD_OPTINS_REQUEST';
export const DOWNLOAD_OPTINS_SUCCESS = 'DOWNLOAD_OPTINS_SUCCESS';
export const DOWNLOAD_OPTINS_FAILURE = 'DOWNLOAD_OPTINS_FAILURE';

export const CREATE_OPTINS_REQUEST = 'CREATE_OPTINS_REQUEST';
export const CREATE_OPTINS_SUCCESS = 'CREATE_OPTINS_SUCCESS';
export const CREATE_OPTINS_FAILURE = 'CREATE_OPTINS_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/privacy/mutation-types.js